<!--
 * @Author: wangliang
 * @LastEditTime: 2023-10-25 10:49:01
 * @Description: 模型库
-->
<template>
  <div class="h-full flex">
    <el-card class="h-full mr-10px w-300px">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">{{
          `${pageTitle}库`
        }}</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="请输入名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
        <el-button size="small" type="primary" @click="$refs.modelTreeTree.filter(treeKeyword)"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="addSourceMaterial"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
      </div>
      <el-tree
        v-if="treeStandBy"
        ref="modelTreeTree"
        :default-expand-all="defaultExpandAll"
        :data="treeData"
        class="modelTree-tree overflow-y-auto"
        :props="{
          children: 'children',
          label: 'name',
        }"
        highlight-current
        node-key="id"
        :draggable="true"
        :allow-drop="allowDrop"
        :expand-on-click-node="false"
        :filter-node-method="filterTree"
        :default-expanded-keys="defaultExpandIds"
        :current-node-key="currentNodeKey"
        @node-drop="handleDrop"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
      >
        <div slot-scope="{ node, data }" class="flex items-center flex-1 overflow-x-hidden">
          <el-tooltip effect="dark" :open-delay="400" :content="node.label" placement="top">
            <span class="text-sm flex-1 mr-10px truncate">{{ node.label }}</span>
          </el-tooltip>
          <el-dropdown class="mr-10px" @command="($event) => handleCommand($event, data)">
            <i class="iconfont icon-line-moreVertical"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="create" :disabled="!$hasAccess('create')"
                >新增</el-dropdown-item
              >
              <el-dropdown-item v-if="data.id" command="edit" :disabled="!$hasAccess('update')"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item v-if="data.id" command="delete" :disabled="!$hasAccess('delete')"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1">
      <div class="mb-20px flex justify-between">
        <div>
          <el-input
            size="small"
            clearable
            :placeholder="`请输入${pageTitle}名称`"
            class="!w-280px mr-10px"
            v-model="searchForm.name"
          />
          <el-checkbox class="!mr-10px" size="small" type="primary" v-model="searchForm.isRecursion"
            >递归显示</el-checkbox
          >
          <el-button
            size="small"
            type="primary"
            @click="searchList()"
            :disabled="!$hasAccess('read')"
            >搜索</el-button
          >
          <!-- <el-button
          size="small"
          type="primary"
          @click="resetSearch()"
          :disabled="!$hasAccess('read')"
          >重置</el-button
        > -->
          <el-button
            size="small"
            type="primary"
            @click="createModelBase"
            :disabled="!$hasAccess('create')"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="batchDeleteModelBase"
            :disabled="!$hasAccess('delete')"
            >删除</el-button
          >
          <el-button
            size="small"
            @click="exportModel(selection)"
            :loading="exportLoading"
            :disabled="!$hasAccess('export')"
            >导出</el-button
          >
          <el-button size="small" @click="importModel(selection)" :disabled="!$hasAccess('import')"
            >导入</el-button
          >
          <el-button
            size="small"
            @click="downloadFile(selection)"
            :disabled="!$hasAccess('download')"
            :loading="downLoading"
            >下载文件</el-button
          >
          <el-button size="small" @click="batchUpload" :disabled="!$hasAccess('batchUpload')"
            >批量上传</el-button
          >
        </div>
        <el-button
          size="small"
          type="primary"
          @click="functionConfigHandler"
          :disabled="!$hasAccess('create')"
          >功能配置</el-button
        >
      </div>
      <section
        v-loading="tableLoading"
        :gutter="10"
        class="relative h-[calc(100%-85px)] flex justify-start content-start flex-wrap overflow-y-auto text-12px"
      >
        <el-card
          v-for="(value, keys) in tableData"
          :key="keys"
          class="card__body--nopadding 2xl:w-[calc(20%-20px)] 2xl:h-212px 2xl:text-14px xl:w-[calc(25%-20px)] xl:h-131px xl:text-14px md:w-[calc(33%-20px)] md:h-127px md:text-12px mr-20px mb-20px"
        >
          <div class="w-full h-full">
            <div class="to-model-preview h-[calc(100%-42px)]" @click="openModelView(value)">
              <el-image class="w-full h-full" :src="value.pathUrl" fit="cover">
                <div slot="error" class="image-slot w-full h-full flex justify-center items-center">
                  <i class="el-icon-picture-outline text-60px"></i></div
              ></el-image>
            </div>
            <div
              class="w-full h-42px flex justify-between px-6px bg-hex-c4c4c4cc model_message_wrap text-white leading-24px"
            >
              <el-checkbox
                class="w-14px !mr-6px"
                v-model="value.isCheck"
                @change="checkBoxChange(value)"
              ></el-checkbox>
              <div class="max-w-[calc(100%-20px)] flex-1 pr-4px">
                <div class="w-full flex justify-between items-center">
                  <el-tooltip effect="dark" :open-delay="400" :content="value.name" placement="top">
                    <span class="flex-1 truncate">{{ value.name }}</span>
                  </el-tooltip>
                  <div class="w-72px">
                    <span
                      :class="!$hasAccess('update') ? 'cursor-not-allowed' : 'cursor-pointer'"
                      @click="editModelBase(value)"
                      >编辑</span
                    ><span class="mx-6px">|</span
                    ><span
                      :class="!$hasAccess('delete') ? 'cursor-not-allowed' : 'cursor-pointer'"
                      @click="deleteModelBase(value.id)"
                      >删除</span
                    >
                  </div>
                </div>
                <div class="w-full pr-10px truncate leading-14px">
                  {{ formatLables(value.lables) || '暂无标签' }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <div class="el-tree__empty-text" v-if="!tableData.length">暂无数据</div>
      </section>
      <el-pagination
        class="text-right relative before:content-[''] before:w-full before:h-20px before:absolute before:top-[-20px] before:left-0 before:bg-$contentBgColor"
        background
        @size-change="searchList()"
        @current-change="findList()"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 50, 100]"
      >
      </el-pagination>
      <wiz-upload-file
        v-dialogDrag
        v-if="showUploadExcelDialog"
        @refreshList="resetSearch"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
        @exportResults="exportResults"
        :pageInfo="pageInfo"
        :uploadFileProps="uploadFileProps"
      ></wiz-upload-file>
      <operate-model-tree-dialog
        v-if="showOperateSourceMaterialDialog"
        :pageInfo="pageInfo"
        :modelTreeProps="modelTreeProps"
        :modelTreeForm="modelTreeForm"
        @closeModelTreeDialog="closeModelTreeDialog"
      ></operate-model-tree-dialog>
      <operate-model-dialog
        v-if="showOperateModelDialog"
        :currentTreeSelect="currentTreeSelect"
        :treeData="treeData"
        :modelProps="modelProps"
        :modelForm="modelForm"
        :flatTreeData="flatTreeData"
        :pageInfo="pageInfo"
        @closeModelDialog="closeModelDialog"
      ></operate-model-dialog>
      <batch-model-upload
        v-if="showBatchUploadDialog"
        :currentTreeSelect="currentTreeSelect"
        :batchUploadProps="batchUploadProps"
        :pageInfo="pageInfo"
        @closeBatchModelUploadDialog="closeBatchModelUploadDialog"
      ></batch-model-upload>
      <function-config v-if="configDialogShow" :visible.sync="configDialogShow" />
    </el-card>
  </div>
</template>
<script>
import {
  forIn,
  get,
  find,
  cloneDeep,
  assign,
  keys,
  pickBy,
  pick,
  omit,
  isEmpty,
  omitBy,
  map,
  isNil,
  eq,
  forEach,
  findIndex,
  isString,
  split,
  join,
  isArray,
} from 'lodash'
import {
  AnimationDirectoryApi,
  ModelDirectoryApi,
  ModelApi,
  AnimationApi,
} from '@wiz-api/material-management'
import { FileApi, TempFileApi } from '@wiz-api/file-management'
import { transferSkipCount } from '@/assets/js/TransferPage'
import FnMixins from '@/assets/js/fnMixins'

// 动效管理时替换 api为animationApi
const modelApi = new ModelApi()
const animationApi = new AnimationApi()
const modelDirectoryApi = new ModelDirectoryApi()
const animationDirectoryApi = new AnimationDirectoryApi()
const fileApi = new FileApi()
const tempFileApi = new TempFileApi()

const OperateModelTreeDialog = () => {
  return import('../components/OperateModelTreeDialog')
}

const OperateModelDialog = () => {
  return import('../components/OperateModelDialog')
}

const BatchModelUpload = () => {
  return import('../components/BatchModelUpload')
}

const FunctionConfig = () => {
  return import('../components/FunctionConfig')
}

export default {
  name: 'modelBase',
  mixins: [FnMixins],
  components: {
    OperateModelTreeDialog,
    OperateModelDialog,
    BatchModelUpload,
    FunctionConfig,
  },
  data() {
    return {
      configDialogShow: false, // 配置功能弹窗
      // 页面信息 默认为模型库页面
      pageInfo: {
        pageTitle: '模型',
        materialType: 1,
      },
      // 表单搜索
      searchForm: {
        name: '',
        isRecursion: true,
      },
      // 模型库目录过滤
      treeKeyword: '',
      // 模型库树加载状态
      treeLoading: false,
      // 模型树数据
      treeData: [],
      // 当前选中节点
      currentTreeSelect: {},
      // 模型库数据
      tableData: [],
      // 分页参数
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      // 模型树弹框显隐
      showOperateSourceMaterialDialog: false,
      // 模型树弹框操作类型
      modelTreeProps: {
        visible: true,
        title: '新增模型库',
        editType: 'create',
      },
      // 模型树弹框表单
      modelTreeForm: {
        name: '',
      },
      // 模型弹框显隐
      showOperateModelDialog: false,
      // 模型弹框操作信息
      modelProps: {
        visible: true,
        title: '新增模型',
        editType: 'create',
      },
      // 模型弹框表单
      modelForm: {
        name: '',
        orderNumber: '',
        directoryId: '',
        lables: [],
        modelFile: '',
        modelClassName: '',
      },
      selection: [],
      // 分类树显隐
      treeStandBy: true,
      // 是否默认展开全部
      defaultExpandAll: false,
      // 当前选择模型
      seleteFile: {},
      // 表格数据加载状态
      tableLoading: false,
      // 批量上传
      showBatchUploadDialog: false,
      // 当前模型操作信息
      batchUploadProps: {
        visible: true,
        title: '批量上传模型',
        editType: 'create',
      },
      // 新增目录层级信息
      addDataInfo: {},
      // 默认展开
      defaultExpandIds: [''],
      // 扁平化数据
      flatTreeData: [],
      // 导入组件显隐
      showUploadExcelDialog: false,
      // 导入描述
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
        downLoading: false, // 下载加载状态
        exportLoading: false, // 导出加载状态
      },
      // 文件下载加载状态
      downLoading: false,
      // 导出加载状态
      exportLoading: false,
      // 模型图片列表加载状态
      modleImageLoadInstance: null,
      // 当前激活node节点id
      currentNodeKey: '',
      // 请求实例
      requestInstance: null,
      // 目录请求实例
      directoryInstance: null,
    }
  },
  created() {
    const { materialType } = this.$route.meta
    switch (materialType) {
      case 1:
        this.requestInstance = modelApi
        this.directoryInstance = modelDirectoryApi
        this.pageInfo = { pageTitle: '模型', materialType }
        break
      case 2:
        // 动效管理时替换 api为animationApi
        this.requestInstance = animationApi
        this.directoryInstance = animationDirectoryApi
        this.pageInfo = { pageTitle: '动效', materialType }
        break
      default:
        break
    }
    this.getTreeData()
    this.resetSearch()
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    jumpPreviewRouter() {
      return (
        Wiz.globalSettings.dynamicModules.modules['source-material-management']?.config
          ?.jumpPreviewRouter || '/visualization-cockpit/index'
      )
    },
    // 表单高度
    tableHeight() {
      return 'calc(100% - 106px)'
    },
    // 页面标题
    pageTitle() {
      return get(this.pageInfo, 'pageTitle')
    },
  },
  methods: {
    // 更改标签连接符
    formatLables(lableStr) {
      return isString(lableStr) ? join(split(lableStr, ';'), ' ') : ''
    },
    // 当前选中ids
    currentCheckModelIds() {
      return keys(pickBy(this.seleteFile, Boolean))
    },
    // 初始化表格数据
    getCheckList(res) {
      return map(res, (item) => {
        return assign(item, {
          // 绑定选择框值
          isCheck: get(this.seleteFile, item.id) || false,
          // 绑定缩略图路径
          pathUrl: item.pathUrl || '',
        })
      })
    },
    // 下载文件
    async downloadFile() {
      if (!get(this.currentCheckModelIds(), 'length')) {
        this.$message.warning('请选择下载文件')
        return
      }
      this.downLoading = true
      const [err, res] = await this.requestInstance.getPackage({
        ids: [...this.currentCheckModelIds()],
      })
      this.downLoading = false
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: `${this.pageTitle}.zip`,
          data: res,
        })
        this.seleteFile = this.$options.data().seleteFile
        this.tableData = this.getCheckList(this.tableData)
        this.$message.success('下载成功')
      }
    },
    // 下载缩略图base64
    async startDownloadImages(imageList) {
      this.modleImageLoadInstance = this.requestLimitFn(5)
      await Promise.all(
        map(imageList, (item) => {
          return this.modleImageLoadInstance.generator(() => {
            return this.getModelBase64(item)
          })
        })
      )
      this.modleImageLoadInstance = null
    },
    // 请求个数并行及顺序控制
    requestLimitFn(limit) {
      let queue = []
      let currentStatus = true
      let activeCount = 0
      // 执行下一个任务
      const next = () => {
        activeCount -= 1
        if (queue.length > 0) {
          const nextFn = queue.shift()
          // 当前为取消状态 结束任务执行
          if (!currentStatus) {
            next()
            return
          }
          nextFn()
        }
      }
      // 执行任务队列
      const run = async (fn, resolve, ...args) => {
        activeCount += 1
        try {
          if (!currentStatus) {
            resolve({})
          }
          const res = await fn(...args)
          resolve(res)
        } finally {
          next()
        }
      }
      // 任务队列初始化
      const enqueue = (fn, resolve, ...args) => {
        queue.push(run.bind(null, fn, resolve, ...args))
        if (activeCount < limit && queue.length > 0) {
          queue.shift()()
        }
      }
      // 任务添加
      const generator = async (fn, ...args) => {
        return new Promise((resolve) => {
          enqueue(fn, resolve, ...args)
        })
      }
      // 任务状态控制
      const requestController = (isRun = true) => {
        currentStatus = isRun
        queue = []
      }
      return { generator, requestController }
    },
    // 结束未完成请求
    initModelImageLoad() {
      if (!isEmpty(this.modleImageLoadInstance)) {
        this.modleImageLoadInstance.requestController(false)
        this.modleImageLoadInstance = null
      }
    },
    // 更具文件id获取缩略图
    async getModelBase64(fileInfo) {
      const { pathUrl, medias, id } = fileInfo
      const targetFileId = get(find(medias, ['mediaType', 3]), 'fileInfoId')
      // 已经存在缩略图
      if (pathUrl || !targetFileId) {
        return Promise.resolve()
      }
      const [err, res] = await fileApi.getFileContent(targetFileId)
      // 返回的是base64
      if (!err) {
        // 判断数据赋值
        const targetIndex = findIndex(this.tableData, ['id', id])
        if (targetIndex === -1) {
          return Promise.resolve()
        }
        this.$set(this.tableData[targetIndex], 'pathUrl', `data:image/jpg;base64,${res.content}`)
      }
      return Promise.resolve()
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await this.requestInstance.getImportExcelTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: `${this.pageTitle}导入模板.xlsx`,
          data: res,
        })
      }
    },
    // 下载导入结果
    async exportResults() {
      const [err, res] = await tempFileApi.download(this.uploadFileProps.resultFile)
      if (!err) {
        this.downLoadBlob({
          name: `${this.pageTitle}导入结果.xlsx`,
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await this.requestInstance.callImport({
        file: formData.get('file'),
      })
      this.uploadFileProps.btnLoading = false
      if (!err) {
        this.uploadFileProps.active = 2
        // 导出结果
        this.uploadFileProps.successCount = res.successfullyCount
        this.uploadFileProps.failureCount = res.failureCount
        this.uploadFileProps.resultFile = res.tempFileId
        this.$message.success(this.$t('theImportToExcelIsSuccessful'))
      }
    },
    // 导入
    importModel() {
      // 导入默认为下载模板
      this.uploadFileProps.active = 0
      this.uploadFileProps.visible = true
      this.showUploadExcelDialog = true
    },
    // 导出
    async exportModel() {
      this.exportLoading = true
      const body = omit(
        {
          name: this.searchForm.name,
          isRecursion: this.searchForm.isRecursion,
          directoryId: this.currentTreeSelect.id,
          ids: [...this.currentCheckModelIds()],
        },
        // 条件导出 或者 框选导出
        isEmpty(this.currentCheckModelIds()) ? ['ids'] : ['name', 'directoryId', 'isRecursion']
      )
      const [err, res] = await this.requestInstance.callExport({
        // 过滤除 0 外的空字段
        body: omitBy(body, (e) => {
          return isNil(e) || eq(e, '')
        }),
        returnType: 'Blob',
      })
      this.exportLoading = false
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: `${this.pageTitle}.xlsx`,
          data: res,
        })
        this.seleteFile = this.$options.data().seleteFile
        this.tableData = this.getCheckList(this.tableData)
        this.$message.success('导出成功')
      }
    },
    // 批量上传弹框关闭
    closeBatchModelUploadDialog(isUpload = false) {
      this.batchUploadProps.visible = false
      this.showBatchUploadDialog = false
      // 成功上传模型
      if (isUpload) {
        this.getTreeData()
        this.resetSearch()
      }
    },
    // 模型树弹框关闭回调
    async closeModelTreeDialog(expandId) {
      this.modelTreeProps.visible = false
      this.showOperateSourceMaterialDialog = false
      // 取消操作刷新数据
      if (eq(expandId, false)) {
        return
      }
      await this.getTreeData()
      this.defaultExpandIds = [expandId, this.currentTreeSelect.parentId || '']
      this.currentNodeKey = this.currentTreeSelect.id
      // 默认展开新增目录层级
      this.treeStandBy = false
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 模型弹框关闭回调
    closeModelDialog(isUpdated) {
      this.modelProps.visible = false
      this.showOperateModelDialog = false
      // 非取消操作刷新数据
      if (isUpdated) {
        this.searchList()
      }
    },
    // 批量上传
    batchUpload() {
      this.showBatchUploadDialog = true
      this.batchUploadProps = assign(this.$options.data().batchUploadProps, {
        title: `批量上传${this.pageTitle}`,
      })
    },
    // 功能配置
    functionConfigHandler() {
      this.configDialogShow = true
    },
    async openModelView(val) {
      const modelInfo = find(val.medias, ['mediaType', 1])
      const textureInfo = find(val.medias, ['mediaType', 2])
      if (modelInfo?.fileInfoId) {
        const [err, res] = await fileApi.get(modelInfo.fileInfoId)
        if (!err) {
          const authorization = localStorage.getItem('authorization')
          const routeUrl = this.$router.resolve({
            path: `${this.basePath}${this.jumpPreviewRouter}`,
            query: {
              modelInfoId: modelInfo.fileInfoId,
              modelInfoType: res.name.split('.')[1] || 'pr',
              textureInfoId: textureInfo ? textureInfo.fileInfoId : '',
              type: _.last(res.name?.split('.')) || 'pr',
              token: authorization || 'null'
            },
          })
          window.open(routeUrl.href, '_blank')
        }
      } else {
        this.$message.warning('模型文件不存在')
      }
    },
    // 模型选择事件
    checkBoxChange(currentVal) {
      const id = get(currentVal, 'id')
      const isCheck = get(currentVal, 'isCheck')
      if (isNil(id) || isNil(isCheck)) {
        return
      }
      this.seleteFile[id] = isCheck
    },
    // 收起、展开全部
    operateTree(bool) {
      this.defaultExpandIds = []
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 自定义树过滤
    filterTree(value, data) {
      return data.name.includes(value)
    },
    /**
     * @description 判断节点能否被拖拽
     */
    allowDrop(draggIngNode, dropNode, type) {
      if (draggIngNode.level === dropNode.level) {
        if (
          (_.isNil(draggIngNode.data.parentId) && _.isNil(dropNode.data.parentId)) ||
          draggIngNode.data.parentId === dropNode.data.parentId
        ) {
          return type === 'prev' || type === 'next'
        }
      }
      return false
    },
    /**
     * @description 拖拽成功事件
     */
    async handleDrop(draggIngNode, dropNode) {
      let count = 0
      const ids = _.map(dropNode.parent.data.children, (item) => {
        count += 1
        return {
          id: item.id,
          seqNo: count,
        }
      })
      const [err, res] = await modelDirectoryApi.updateSeqNoMany({
        body: ids,
      })
    },
    // 获取模型树
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await this.directoryInstance.getTree()
      if (!err && !isNil(res)) {
        this.flatTreeData = this.transformList(res)
        this.treeData = [{ name: '根目录', id: '', children: res }]
      }
      this.treeLoading = false
    },
    // 扁平化模型树
    transformList(data, resultList = []) {
      if (!isArray(data)) {
        return []
      }
      forEach(data, (node) => {
        resultList.push(pick(node, ['id', 'name', 'path']))
        this.transformList(node.children, resultList)
      })
      return resultList
    },
    // 模型库树点击
    handleNodeClick(node) {
      this.currentTreeSelect = node
      this.searchList()
    },
    // 表格按钮事件
    handleCommand(command, data) {
      switch (command) {
        case 'edit':
          this.editSourceMaterial(data)
          break
        case 'delete':
          this.deleteSourceMaterial(data.id)
          break
        case 'create':
          this.addSourceMaterial(data)
          break
        default:
          break
      }
    },
    // 修改模型库
    editSourceMaterial(row) {
      this.modelTreeProps = assign(this.$options.data().modelTreeProps, {
        title: `编辑${this.pageTitle}库`,
        editType: 'edit',
      })
      this.modelTreeForm = cloneDeep(row)
      this.showOperateSourceMaterialDialog = true
    },
    // 新增模型
    createModelBase() {
      this.showOperateModelDialog = true
      this.modelProps = assign(this.$options.data().modelProps, {
        title: `新增${this.pageTitle}`,
      })
      this.modelForm = this.$options.data().modelForm
    },
    // 批量删除
    batchDeleteModelBase() {
      if (!this.currentCheckModelIds().length) {
        this.$message.warning('请先勾选模型')
        return
      }
      this.$confirm('此操作将永久删除，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await this.requestInstance.deleteMany({
          ids: this.currentCheckModelIds(),
        })
        if (!err) {
          this.$message.success('删除成功')
          this.seleteFile = this.$options.data().seleteFile
          this.findList()
        }
      })
    },
    // 编辑模型
    editModelBase(row) {
      if (!this.$hasAccess('update')) {
        return
      }
      this.showOperateModelDialog = true
      this.modelProps = assign(this.$options.data().modelProps, {
        title: `编辑${this.pageTitle}`,
        editType: 'edit',
      })
      this.modelForm = assign(cloneDeep(row), {
        modelClassName: get(find(this.flatTreeData, ['id', row.directoryId]), 'path'),
      })
    },
    // 删除模型
    deleteModelBase(id) {
      if (!this.$hasAccess('delete')) {
        return
      }
      this.$confirm('此操作将永久删除，是否继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err] = await this.requestInstance.callDelete(id)
        if (!err) {
          this.$message.success('删除成功')
          this.findList()
        }
      })
    },
    // 新增模型库
    addSourceMaterial(data = {}) {
      this.modelTreeForm = cloneDeep(omit(data, ['name', 'path']))
      this.modelTreeProps = assign(this.$options.data().modelTreeProps, {
        title: `新增${this.pageTitle}库`,
      })
      this.showOperateSourceMaterialDialog = true
    },
    // 重置搜索
    resetSearch() {
      this.currentTreeSelect = this.$options.data().currentTreeSelect
      this.searchForm = this.$options.data().searchForm
      this.searchList()
    },
    // 带条件情况分页搜索
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    // 列表搜索
    async findList() {
      this.tableLoading = true
      this.initModelImageLoad()
      const [err, res] = await this.requestInstance.getList({
        name: this.searchForm.name,
        isRecursion: this.searchForm.isRecursion,
        directoryId: this.currentTreeSelect.id,
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      })
      this.tableLoading = false
      if (!err) {
        this.tableData = this.getCheckList(res.items)
        this.startDownloadImages(this.tableData)
        this.page.pageTotal = res.totalCount
      }
    },
    // 删除模型库
    deleteSourceMaterial(id) {
      this.$confirm('此操作将永久删除，是否继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err] = await this.directoryInstance.callDelete(id)
        if (!err) {
          this.$message.success('删除成功')
          this.getTreeData()
          // 删除当前选中节点清空列表数据
          if (eq(get(this.currentTreeSelect, 'id'), id)) {
            this.tableData = []
            this.currentTreeSelect = {}
          }
        }
      })
    },
  },
  deactivated() {
    this.initModelImageLoad()
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: calc(100%);
}
.card__body--nopadding ::v-deep .el-card__body {
  padding: 10px;
}
.to-model-preview {
  cursor: pointer;
}
.model_message_wrap {
  background-color: #f5f5f5 !important;
  color: #000000 !important;
  ::v-deep .el-checkbox__inner {
    border-color: #000000 !important;
  }
}

.modelTree-tree {
  height: calc(100% - 84px);
}
</style>
